module.exports = __webpack_public_path__ + "img/clients.dedbc4e6.svg";